import { Point2D, SceneObjectBounds } from './types';

export const getBoundsFromPoints = (points: readonly Point2D[]): SceneObjectBounds => {
  let minX = Infinity;
  let maxX = -Infinity;
  let minY = Infinity;
  let maxY = -Infinity;

  for (const point of points) {
    if (point.x < minX) minX = point.x;
    if (point.x > maxX) maxX = point.x;
    if (point.y < minY) minY = point.y;
    if (point.y > maxY) maxY = point.y;
  }

  return {
    position: { x: (minX + maxX) / 2, y: (minY + maxY) / 2 },
    size: { width: maxX - minX, height: maxY - minY },
  };
};
